export const deleteMenuDialogTranslations = {
    en: {
        confirmMessage: 'Are you sure you want to delete the menu ?',
        yes: "Yes",
        deleteSuccess: "Menu Deleted Successfully",
        deleteError: "Something went wrong. Please try again later."
    },
    mr: {
        confirmMessage: 'तुम्हाला खात्री आहे की तुम्ही मेनू हटवू इच्छिता?',
        yes: "होय",
        deleteSuccess: "मेनू यशस्वीरित्या हटवला",
        deleteError: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा."
    }
};
